module.exports = __webpack_public_path__ + "static/media/Brushcantrailerhanddesignedandlettered2017.f921e847.webp";